import { Injectable } from '@angular/core';
import { FlujosPaso2PJService } from 'src/app/global/services/flujos-paso-2-pj.service';
import { Flujo } from '../../../interfaces/flujo';


@Injectable()
export class FlujosPaso2PJProvider extends FlujosPaso2PJService {

  paso1Created = false;

  datosEmpresa: Flujo;

  configuracionProducto: Flujo;

  datosSocio: Flujo;

  datosAdjuntos: Flujo;

  cuentaBancaria: Flujo;

  constructor() {
    super();
    this.datosEmpresa = {
      cargando: true,
      mostrar: false,
      ok: false,
      visible: true,
      bloqueado: false,
      edicion: true
    };

    this.configuracionProducto = {
      cargando: false,
      mostrar: false,
      ok: false,
      visible: false,
      bloqueado: true,
      edicion: true
    };

    this.datosSocio = {
      cargando: false,
      mostrar: false,
      ok: false,
      visible: true,
      bloqueado: true,
      edicion: true
    };

    this.datosAdjuntos = {
      cargando: false,
      mostrar: false,
      ok: false,
      visible: true,
      bloqueado: true,
      edicion: true
    };

    this.cuentaBancaria = {
      cargando: false,
      mostrar: false,
      ok: false,
      visible: true,
      bloqueado: true
    };

    this.formularioUAF = {
      cargando: false,
      mostrar: false,
      ok: false,
      visible: true,
      bloqueado: true
    };
  }

  setEdicionFalse() {
    this.datosEmpresa.edicion = false;
    this.configuracionProducto.edicion = false;
    this.datosSocio.edicion = false;
    this.datosAdjuntos.edicion = false;
  }
}
